<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">纸条审核</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>类型：</label>
          <el-select v-model="type" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>人审状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>机审状态：</label>
          <el-select v-model="machineAuditState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in machineAuditStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>禁言：</label>
          <el-select v-model="bannedChatState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in bannedChatStateList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>封号：</label>
          <el-select v-model="forbiddenState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in forbiddenStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>设备：</label>
          <el-select v-model="idfaBanState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in idfaBanStateList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>隐藏：</label>
          <el-select v-model="isDel" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in isDelList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <el-input v-model="msgId" placeholder="请输入序号" :disabled="checked" style="width:8em;margin-right: 8px;"></el-input>
          <el-checkbox v-model="checked">不限序号</el-checkbox>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="success" v-loading="updateLoading" @click="batchUpdate(2)">批量通过</el-button>
          <el-button type="danger" v-loading="updateLoading" @click="batchUpdate(3)">批量不通过</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            v-loading="listLoading"
        >
          <el-table-column type="selection" width="40" align="center" class-name="cursor"/>
          <el-table-column property="createTime" label="时间" v-if="checkColList.indexOf('时间') > -1"/>
          <el-table-column prop="msg" label="内容" v-if="checkColList.indexOf('内容') > -1">
            <template #default="scope">
              <p v-html="scope.row.msg"></p>
            </template>
          </el-table-column>
          <el-table-column property="msgId" label="留言序号" v-if="checkColList.indexOf('留言序号') > -1"/>
          <el-table-column prop="" label="类型" v-if="checkColList.indexOf('类型') > -1">
            <template #default="scope">
              <span>{{scope.row.type == -1 ? '纸条' : '回复'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="发送人" v-if="checkColList.indexOf('发送人') > -1" width="106">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="发送人信息" v-if="checkColList.indexOf('发送人信息') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city"/>
            </template>
          </el-table-column>
          <el-table-column label="接收人" v-if="checkColList.indexOf('接收人') > -1" width="106">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.toResumeInfo.headImg.smallHeadImg" @click="showImg(scope.row.toResumeInfo)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="接收人信息" v-if="checkColList.indexOf('接收人信息') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row.toResumeInfo" showList="name,phone,uid,city"/>
            </template>
          </el-table-column>
          <el-table-column property="" label="人审状态" v-if="checkColList.indexOf('人审状态') > -1">
            <template #default="scope">
              <p>{{scope.row.state == 1 || scope.row.state == 0 ? '待审核' : scope.row.state == 2 ? '通过' : scope.row.state == 3 ? '不通过' : ''}}</p>
              <p>{{scope.row.msgDtDel == 1 ? '用户已删除' : ''}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="机审状态" v-if="checkColList.indexOf('机审状态') > -1">
            <template #default="scope">
              <p>{{scope.row.machineAuditState == 1 ? '通过' : scope.row.machineAuditState == 2 ? '不通过' : ''}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1" class-name="cursor" width="70">
            <template #default="scope">
              <p v-if="scope.row.isBannedChat">已禁言</p>
              <p v-if="scope.row.isIdfaBan">已冻结</p>
              <p v-if="scope.row.isDel == 1">已隐藏</p>
              <p v-if="scope.row.isForbidden">已封号</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1" class-name="cursor" >
            <template #default="scope">
<!--              <el-space direction="vertical" alignment="left">-->
<!--                &lt;!&ndash;                <el-button type="primary" size="small" @click="appointAuth(scope.row)">指定认证</el-button>&ndash;&gt;-->
<!--                <el-button v-if="scope.row.isDel==1" type="success" size="small" v-loading="scope.row.delLoading" @click="updateResumeDelState(scope.$index, scope.row, 0, '取消隐藏')">取消隐藏</el-button>-->
<!--                <el-button v-if="scope.row.isDel==0" type="primary" size="small" v-loading="scope.row.delLoading" @click="updateResumeDelState(scope.$index, scope.row, 1, '隐藏')">隐藏</el-button>-->
<!--                <el-button v-if="!scope.row.isBannedChat" type="primary" size="small" @click="updateBannedChat(scope.$index, scope.row, 1)">禁言</el-button>-->
<!--                <el-button v-if="scope.row.isBannedChat" type="success" size="small" @click="updateBannedChat(scope.$index, scope.row, 2)" v-loading="scope.row['bannedLoading']">解除禁言</el-button>-->
<!--&lt;!&ndash;                <el-button v-if="scope.row.screenState == 0" type="primary" size="small" @click="updateScreenState(scope.$index, scope.row, 1)" v-loading="scope.row['screenLoading']">屏蔽</el-button>&ndash;&gt;-->
<!--&lt;!&ndash;                <el-button v-if="scope.row.screenState == 1" type="success" size="small" @click="updateScreenState(scope.$index, scope.row, 0)" v-loading="scope.row['screenLoading']">取消屏蔽</el-button>&ndash;&gt;-->
<!--                <el-button v-if="!scope.row.isForbidden" type="primary" size="small" @click="updateUserForbidden(scope.$index, scope.row, 1)" v-loading="scope.row['forbiddenLoading']">封号</el-button>-->
<!--                <el-button v-if="scope.row.isForbidden" type="success" size="small" @click="updateUserForbidden(scope.$index, scope.row, 2)" v-loading="scope.row['forbiddenLoading']">解除封号</el-button>-->
<!--                <el-button v-if="scope.row.isIdfaBan" type="success" size="small" @click="updateUserIdfaBan(scope.$index, scope.row, 1)" v-loading="scope.row['isIdfaBanLoading']">解除冻结</el-button>-->
<!--                <AppointAuth :row="scope.row" />-->
<!--              </el-space>-->
              <ActionButton :row="scope.row" showList="hide,forbidden,idfa,chat,point"/>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="180">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import ActionButton from "@/components/resume/ActionButton";
import {
  getMsgPageList,
  updateMsgDtState,
  updateUserBannedChat,
  updateScreenState,
  updateUserForbidden,
  updateResumeDelState, updateUserIdfaBan
} from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import { common } from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
// import ChatUserList from "./components/content/ChatUserList"
// import MsgUserList from "./components/content/MsgUserList"
import BannedChatDialog from "@/components/resume/BannedChatDialog";
import ForbiddenDialog from '@/components/resume/ForbiddenDialog'
// import ipCityAbnormalDialog from '@/components/resume/ipCityAbnormalDialog'
// import AppointAuthDialog from "@/components/resume/AppointAuthDialog";
import AppointAuth from "@/components/resume/AppointAuth";

export default {
  name: "InteractMsg",
  components: { DatePickerRange, SearchComponents, UserLog, AppointAuth, ActionButton },
  data() {
    return {

      sexArray: common.sexList,
      sex: common.sexList[0]['value'],

      //类型
      typeArray: [
        {label: "不限",value: -2},
        {label: "纸条",value: -1},
        {label: "回复",value: 2}
      ],
      type:-2,

      //人审状态
      stateArray: [
        {label: "不限",value: -1},
        {label: "待审核",value: 1},
        {label: "已通过",value: 2},
        {label: "未通过",value: 3}
      ],
      state: 1,

      //机审状态
      machineAuditStateArray: [
        {label: "不限",value: -1},
        {label: "通过",value: 1},
        {label: "不通过",value: 2}
      ],
      machineAuditState: 2,

      //禁言
      bannedChatStateList: [
        {label: "不限", value: -1},
        {label: "正常", value: 0},
        {label: "已禁言", value: 1},
      ],
      bannedChatState: -1,

      //封号
      forbiddenStateArray: [
        {label: "不限", value: -1},
        {label: "正常", value: 0},
        {label: "已封号", value: 1},
      ],
      forbiddenState: -1,

      //设备
      idfaBanStateList: [
        {label: "不限", value: -1},
        {label: "正常", value: 0},
        {label: "已冻结", value: 1},
      ],
      idfaBanState: -1,

      //隐藏
      isDelList: [
        {label: "不限", value: -1},
        {label: "未隐藏", value: 0},
        {label: "隐藏中", value: 1},
      ],
      isDel: -1,

      //IM/纸条时间
      startTime: '',
      endTime: '',
      isChecked: false,

      //序号
      msgId: '',
      checked: false,

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '用户ID', value : 3},
        {label : '内容', value : 4},
      ],
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['时间', '内容', '留言序号', '类型', '发送人', '发送人信息', '接收人', '接收人信息', '人审状态', '机审状态', '状态', '操作', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],

      idArray: [],
      updateLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getRegTime(val) {
      this.userStartTime = val[0];
      this.userEndTime = val[1];
      // console.log(val)
    },
    getRegCheck(val) {
      this.isRegChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.checked = false;
      this.sex = -1;
      this.type = -2;
      this.state = 1;
      this.machineAuditState = 2;
      this.bannedChatState = -1;
      this.forbiddenState = -1;
      this.idfaBanState = -1;
      this.isDel = -1;
      this.searchValue = '';
      this.msgId = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['type'] = this.type;
      param['state'] = this.state;
      param['machineAuditState'] = this.machineAuditState;
      param['bannedChatState'] = this.bannedChatState;
      param['forbiddenState'] = this.forbiddenState;
      param['idfaBanState'] = this.idfaBanState;
      param['isDel'] = this.isDel;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      if(this.msgId == '' || this.checked){
        param['msgId'] = -1;
      }else{
        param['msgId'] = this.msgId;
      }
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getMsgPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

    },


    //审查
    batchUpdate(state) {
      if(this.idArray.length > 0) {
        this.$confirm('确认批量'+ (state == 2?'【通过】':'【不通过】') +'选中的纸条？').then(()=>{
          this.updateLoading = true;
          let _this = this;
          let param = {};
          param['idArr'] = this.idArray;
          param['state'] = state;
          postFormData(updateMsgDtState, param).then((data) => {
            let {code, msg} = data;
            if(code == 200) {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              });
              for(let j=0;j<_this.idArray.length;j++){
                for(let i=0;i<_this.pageDataList.length;i++) {
                  if(_this.pageDataList[i]['id'] == _this.idArray[j]) {
                    _this.pageDataList.splice(i,1);
                    i--;
                  }
                }
              }
              if(_this.pageDataList.length == 0){
                _this.getPage();
              }
            }else {
              _this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              });
            }
            _this.updateLoading = false;
          })
              .catch(()=>{
                _this.updateLoading = false;
              })
        })
      }else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一个用户进行操作',
          type: 'warning'
        })
      }
    },

    //冻结设备
    updateUserIdfaBan(idx, row, state) {
      this.$confirm('确定' + (state == 0?'冻结':'解冻') + '用户' +'【' + row.nickName + '】的设备?').then(()=>{
        this.pageDataList[idx]['isIdfaBanLoading'] = true
        let param = {}
        param['id'] = row.userId
        param['state'] = state
        postFormData(updateUserIdfaBan, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.pageDataList[idx]['isIdfaBan'] = state == 0?true:false
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['isIdfaBanLoading'] = false
        }).catch(()=>{
          this.pageDataList[idx]['isIdfaBanLoading'] = false
        })
      })
    },

    //展示、隐藏、注销
    updateResumeDelState(idx, row, state, type) {
      this.$confirm('确认' + type + '用户【' + row.nickName + '】简历？').then(() => {
        if(state == 2) {
          this.pageDataList[idx]['_delLoading'] = true
        } else {
          this.pageDataList[idx]['delLoading'] = true
        }
        let param = {};
        param['id'] = row.userId;
        param['del'] = state;
        let _this = this;
        postFormData(updateResumeDelState, param).then(function(data) {
          let code = data.code;
          let msg = data.msg;
          if(code == 200) {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            _this.pageDataList[idx]['isDel'] = state;
          } else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          _this.pageDataList[idx]['delLoading'] = false;
          _this.pageDataList[idx]['_delLoading'] = false;
        })
            .catch(function(response) {
              _this.pageDataList[idx]['delLoading'] = false;
              _this.pageDataList[idx]['_delLoading'] = false;
            })
      })
    },

    //单个禁言/解除
    updateBannedChat(idx, row, state) {
      let userIdArr = [];
      userIdArr.push(row.userId);
      if(state == 1) {
        Dialog.open({
          title: '禁言时间',
          component: BannedChatDialog,
          data: {
            userIdArray: userIdArr,
            width: '500px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }else if (state == 2) {
        this.$confirm('确定对用户【'+ row.nickName + '】解除禁言？')
            .then(() => {
              this.pageDataList[idx]['bannedLoading'] = true
              let param = {}
              param['idArr'] = userIdArr
              param['state'] = 2
              param['day'] = 0
              postFormData(updateUserBannedChat, param).then((data) => {
                let {code, msg} = data;
                if ( code == 200 ) {
                  this.$message({
                    message: msg,
                    duration: 2000,
                    type: 'success'
                  })
                  this.pageDataList[idx]['isBannedChat'] = false
                } else {
                  this.$message({
                    message: msg,
                    duration: 2000,
                    type: 'warning'
                  })
                }
                this.pageDataList[idx]['bannedLoading'] = false
              }).catch(()=>{
                this.pageDataList[idx]['bannedLoading'] = false
              })
            })
            .catch(() => {
              // catch error
            })
      }
    },

    //更新屏蔽状态
    // updateScreenState(idx, row, state) {
    //   this.$confirm('确定' + (state==1?'【屏蔽】用户':'【取消屏蔽】用户') +'【' + row.nickName + '】?').then(()=>{
    //     this.pageDataList[idx]['screenLoading'] = true
    //     let param = {}
    //     param['id'] = row.userId
    //     param['screenState'] = state
    //     postFormData(updateScreenState, param).then((data)=>{
    //       let {code, msg} = data
    //       if(code == 200) {
    //         this.$message({
    //           showClose: true,
    //           duration: 1000,
    //           message: msg,
    //           type: 'success'
    //         })
    //         this.pageDataList[idx]['screenState'] = state
    //       }else {
    //         this.$message({
    //           showClose: true,
    //           duration: 1000,
    //           message: msg,
    //           type: 'warning'
    //         })
    //       }
    //       this.pageDataList[idx]['screenLoading'] = false
    //     }).catch(()=>{
    //       this.pageDataList[idx]['screenLoading'] = false
    //     })
    //   })
    // },

    //更新封号状态
    updateUserForbidden(idx, row, state) {
      if(state == 1) {
        Dialog.open({
          title: '确定对用户【' + row.nickName + '】封号？',
          component: ForbiddenDialog,
          data: {
            userId: row.userId,
            width: '500px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      } else if(state == 2) {
        this.$confirm('确定【取消封号】用户' +'【' + row.nickName + '】?').then(()=>{
          this.pageDataList[idx]['forbiddenLoading'] = true
          let param = {}
          param['id'] = row.userId
          param['state'] = state
          param['type'] = 99
          param['idfaBanState'] = 0
          postFormData(updateUserForbidden, param).then((data)=>{
            let {code, msg} = data
            if(code == 200) {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              })
              this.pageDataList[idx]['isForbidden'] = false
            }else {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              })
            }
            this.pageDataList[idx]['forbiddenLoading'] = false
          }).catch(()=>{
            this.pageDataList[idx]['forbiddenLoading'] = false
          })
        })
      }
    },

    // //用户异常ip列表
    // openIpCityDialog(idx, row) {
    //   Dialog.open({
    //     title: '用户【' + row.nickName + '】异常ip列表',
    //     component: ipCityAbnormalDialog,
    //     data: {
    //       id: row.userId,
    //       width: '600px',
    //       ipState: row.ipState,
    //     },
    //     confirm: (result) => {
    //       this.pageDataList[idx]['ipState'] = result.state
    //     }
    //   })
    // },

    // // 指定认证
    // appointAuth(row) {
    //   Dialog.open({
    //     title: '指定用户【'+ row.nickName +'】去认证？',
    //     component: AppointAuthDialog,
    //     data: {
    //       identity: row.recheckAuthIdentity,
    //       zhima: row.recheckAuthZhima,
    //       video: row.recheckAuthVideo,
    //       identityState: row.identityAuth.identityState,
    //       baiduState: row.identityAuth.baiduState,
    //       zhimaCertifyState: row.identityAuth.zhimaState,
    //       videoState: row.authVideo?row.authVideo.state:'',
    //       cancelVideoAuth: row.cancelVideoAuth,
    //       cancelIdentityAuth: row.cancelIdentityAuth,
    //       cancelZhimaAuth: row.cancelZhimaAuth,
    //       userId: row.userId,
    //       width: '400px'
    //     },
    //     confirm: (result) => {
    //       if(result.type == 1) {
    //         row.cancelIdentityAuth = result.state;
    //       } else if(result.type == 2) {
    //         row.cancelZhimaAuth = result.state;
    //       } else if(result.type == 3) {
    //         row.cancelVideoAuth = result.state;
    //       } else {
    //         row.recheckAuthIdentity = result.recheckAuthIdentity;
    //         row.recheckAuthZhima = result.recheckAuthZhima;
    //         row.recheckAuthVideo = result.recheckAuthVideo;
    //       }
    //     }
    //   })
    // },

  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
